<div class="team-dd-mob selectedballs-container session-fab-container" style="display: block">
    <!-- <div>{{game?.game_context?.FomoBingo?.fomo_numbers==null ? 0:currentGame?.game_context?.FomoBingo?.fomo_numbers.length}}
  /{{numbers.length}}</div> -->
    <div
        class="fab"
        class="teamList fb-list team-fb-mob"
        *ngIf="game?.game_context?.FomoBingo?.fomo_numbers == null || game?.game_context?.FomoBingo?.fomo_numbers?.length == 0">
        <span class="teamName">{{ content.FabGrabTopandTailNo }}</span>
        <span class="numberSelect" (click)="selectNumbers(true)">{{ content.FabGrabSelectNumbers }}</span>
        <i class="theme-info-i" (click)="showInfo(game?.game_context?.FomoBingo?.maximum_numbers)"></i>
    </div>
    <div class="fab" *ngIf="game?.game_context?.FomoBingo?.fomo_numbers != null && game?.game_context?.FomoBingo?.fomo_numbers?.length > 0">
        <span class="teamName">{{ content.FabGrabTopandTailNumber }}</span>
        <div class="sel-numbers">
            <ng-template
                *ngIf="
                    game?.game_context?.FomoBingo?.previous_fomo_numbers?.length > 0 && game?.game_context?.FomoBingo?.fomo_numbers?.length <= 0;
                    else fomo
                ">
                <span class="numballs active" *ngFor="let number of game?.game_context?.FomoBingo?.previous_fomo_numbers"> {{ number }}</span>
            </ng-template>
            <ng-template #fomo>
                <span class="numballs active" *ngFor="let number of game?.game_context?.FomoBingo?.fomo_numbers"> {{ number }}</span>
            </ng-template>
            <span class="numberSelect" *ngIf="!isPurchased" (click)="selectNumbers(true)">{{ content.FabGrabEdit }}</span>
            <!-- <span class="numberSelect" *ngIf="Game.maximum_tickets == Game.purchased_count">{{content.FabGrabLocked}}</span> -->
        </div>
    </div>
</div>

<!-- <div *ngIf="selectNumbersModal && !isPurchased" class="teamSelectModal-overlay"></div>
<div *ngIf="selectNumbersModal && !isPurchased" class="teamSelectModal fab">
    <div class="head-part">{{fabgrabPopupHeader}}<i class="theme-ex" (click)="onNumbersClose()"></i></div>
    <div class="sel-numbers">
        <p>{{fabgrabPopupMessage}}</p>
        <div class="specs">
            <span class="lucky-dip" [class.backGround]="currentGame?.game_context?.FomoBingo?.fomo_numbers?.length>0"
                (click)="selectPattern('')">LUCKY DIP</span>
            <span class="clear" (click)="clearNumbers()">{{content.FabGrabClear}}</span>
        </div>
        <span *ngFor="let number of numbers" (click)="onNumberSelect(number)" class="numballs"
            [ngClass]="currentGame?.game_context?.FomoBingo?.fomo_numbers?.indexOf(number) > -1 ? 'active':''">
            {{number}}</span>
    </div>
    <div class="select-btn">
        <span class="select" (click)="onNumbersClose()">{{content.FabGrabSelect}}</span>
    </div>
</div> -->
